export default __webpack_public_path__ + "static/media/da.5ac41aaa.mp3";